import React from 'react';
import PropTypes from 'prop-types';

import ExternalLink from 'components/Widgets/ExternalLink';

export default function Downloads({ step }) {
  const action = step.actions.find((item) => item.action === 'download');

  return (

    <ExternalLink
      href={action.link}
      variant={null}
      className="btn btn-light btn-reverse ms-3 mb-3 mb-lg-0 step-action-btn"
    >
      Report
    </ExternalLink>
  );
}

Downloads.propTypes = {
  step: PropTypes.object.isRequired,
};
